import type { ChatListSidebarItem } from './schema'

/**
 * Avoids re-rendering the chat list when its displayed headers have not changed.
 */
export const conversationHeaderListEquality = (prevList: ChatListSidebarItem[], nextList: ChatListSidebarItem[]): boolean => {
  if (prevList.length !== nextList.length) return false
  for (let i = 0; i < prevList.length; i++) {
    const prev = prevList[i]
    const next = nextList[i]
    if (prev.id !== next.id || prev.modified_on !== next.modified_on || prev.title !== next.title || prev.unread !== next.unread) return false
  }
  return true
}
